// extracted by mini-css-extract-plugin
export default {"certificate":"certificate_certificate__Q4pci","text":"certificate_text__QWsL5","btn":"certificate_btn__owfzT","modal":"certificate_modal__aIiPH"};